'use client';

import { useRumIdentity } from './use-rum-identity';

/**
 * Mount inside a provider tree that exposes `UserProfileContext` (Pages Router)
 * or `UserDetailsContext` (App Router). Renders nothing; only drives the RUM
 * identity side-effect via `useRumIdentity`.
 */
export const RumIdentitySync: React.FC = () => {
  useRumIdentity();
  return null;
};
